import Hero from '../sections/Hero.jsx';
import Process from '../sections/Process.jsx';
import Fit from '../sections/Fit.jsx';
import Positioning from '../sections/Positioning.jsx';

export default function Home() {
  return (
    <>
      <Hero />
      <Process />
      <Fit />
      <Positioning />
    </>
  );
}
